import { render } from "./ResiView.vue?vue&type=template&id=62ee8bb0&scoped=true"
import script from "./ResiView.vue?vue&type=script&lang=js"
export * from "./ResiView.vue?vue&type=script&lang=js"

import "./ResiView.vue?vue&type=style&index=0&id=62ee8bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ee8bb0"]])

export default __exports__